import { getChatGroupInitialState } from '../constants';
import { IChatGroup } from '../../../../../../../rest/effects/chats/group/types';
import { TChatGroupAction } from '../actions/types';
import { AT_UPDATE } from '../actions/constants';

const initialState: IChatGroup = getChatGroupInitialState();

export const chatGroupReducer = (
    state = initialState,
    action: TChatGroupAction,
): IChatGroup => {
    switch (action.type) {
        case AT_UPDATE: {
            return {
                ...state,
                ...action.group,
            }
        }
        default:
            return state;
    }
};
